import React, { useEffect } from 'react';
import ReactTooltip from 'react-tooltip';
import InfoIcon from '../../icons/infoIcon';
import { Field } from 'formik';

const SearchInputLabel = ({ label = '', name = '', hintText = '', labelButton = '', checkbox = null, warningIcon = null, warningMessage = '' }) => {
  useEffect(() => {
    if (warningIcon && warningMessage) {
      ReactTooltip.rebuild();
    }
  }, [warningIcon, warningMessage]);

  return (
    <div className="flex items-center w-full h-4 mb-1">
      <label className="text-xs font-semibold text-gray-700">{label}</label>
      {/* TODO: hidden until its implementation

      {name && (
        <>
          <div className="h-3 w-3 ml-1">
            <InfoIcon data-tip data-for={`tooltip-${name}`} />
          </div>
          <ReactTooltip id={`tooltip-${name}`} effect="solid" place="right">
            <span>{hintText}</span>
          </ReactTooltip>
        </>
      )}*/}
      {warningIcon && warningMessage && (
        <>
          <div
            className="h-5 w-5 ml-1 cursor-pointer flex items-center justify-center"
            data-tip
            data-for={`warning-tooltip-${name}`}
          >
            {warningIcon}
          </div>
          <ReactTooltip id={`warning-tooltip-${name}`} effect="solid" place="right">
            <span>{warningMessage}</span>
          </ReactTooltip>
        </>
      )}
      {checkbox && (
        <div className="ml-2 flex items-center">
          {checkbox}
        </div>
      )}
      {labelButton && (
        <div className="ml-auto leading-none">{labelButton}</div>
      )}
    </div>
  );
};

export default SearchInputLabel;
